import { ConfirmationModal } from '@folio/stripes/components';
import React from 'react';
import { t } from '../../services';
export var CancelEditModal = function (_a) {
    var onCancel = _a.onCancel, onKeepEdit = _a.onKeepEdit, open = _a.open;
    return (React.createElement(ConfirmationModal, { confirmLabel: t('list.modal.keep-edit'), cancelLabel: t('list.modal.cancel-edit'), heading: t('list.model.sure-heading'), message: t('list.modal.confirm-cancel-message'), onCancel: onCancel, onConfirm: onKeepEdit, open: open }));
};
